// Escaños en semicírculo, como en prototype/simulador.html. viewBox 600 × 330.

export type SeatPosition = { x: number; y: number };
export type Layout = { seats: SeatPosition[]; radius: number };

export const VIEW = { width: 600, height: 330, cx: 300, cy: 305 } as const;

/** Filas según el tamaño: el prototipo usa 3 (4 con más de 30); con pocos escaños, menos. */
export const rowsFor = (n: number) => (n <= 8 ? 1 : n <= 16 ? 2 : n <= 30 ? 3 : 4);

/**
 * Reparte n escaños en filas, proporcional al largo de cada arco, y los ordena de izquierda a
 * derecha. El radio del escaño se ajusta para que no se encimen.
 */
export function layout(n: number): Layout {
  if (n <= 0) return { seats: [], radius: 0 };
  const rows = rowsFor(n);
  const inner = rows === 1 ? 220 : 135;
  const outer = 280;
  const step = rows === 1 ? 60 : (outer - inner) / (rows - 1);
  const radii = Array.from({ length: rows }, (_, i) => inner + i * step);
  const sum = radii.reduce((a, b) => a + b, 0);
  const counts = radii.map((r) => Math.round((n * r) / sum));
  counts[rows - 1]! += n - counts.reduce((a, b) => a + b, 0);

  const placed: Array<SeatPosition & { theta: number; r: number }> = [];
  radii.forEach((r, i) => {
    const c = counts[i]!;
    for (let j = 0; j < c; j++) {
      const theta = Math.PI * (1 - (c === 1 ? 0.5 : j / (c - 1)));
      placed.push({ x: VIEW.cx + r * Math.cos(theta), y: VIEW.cy - r * Math.sin(theta), theta, r });
    }
  });
  placed.sort((a, b) => b.theta - a.theta || a.r - b.r);

  let minArc = Infinity;
  radii.forEach((r, i) => {
    if (counts[i]! > 1) minArc = Math.min(minArc, (Math.PI * r) / (counts[i]! - 1));
  });
  const radius = Math.min(16, minArc * 0.42, step * 0.4);
  return { seats: placed.map(({ x, y }) => ({ x, y })), radius };
}
